import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const DropIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '70%' : '100%'}
      height={circled ? '70%' : '100%'}
      viewBox="0 0 10.057 14.13"
    >
      <defs>
        <clipPath>
          <rect width="10.057" height="14.13" transform="translate(0 0)" fill="none" stroke={color} strokeWidth="1" />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clipPath)">
          <path
            d="M5.028,13.38A4.361,4.361,0,0,0,9.306,8.94C9.306,6.489,5.028.75,5.028.75S.75,6.489.75,8.94A4.361,4.361,0,0,0,5.028,13.38Z"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
